// Documents stored against a plan / order (backend plan_files.py). Goes in src/API/PlanFilesAPI.js
const token = () => localStorage.getItem("agentToken");
const auth = () => ({ Authorization: "Bearer " + token() });

const fail = async (response, message) => {
  let detail = "";
  try {
    detail = (await response.json()).detail || "";
  } catch (e) {
    /* no body */
  }
  throw new Error(`${message} (${response.status})${detail ? ": " + detail : ""}`);
};

// Any file type is accepted. Only the size limit of the server (MAX_UPLOAD_MB, default 10) is checked up front.
export const MAX_FILE_MB = 10;
export const ACCEPT = undefined; // no restriction in the file picker

export const checkFile = (file) => {
  if (file.size === 0) return `${file.name}: die lêer is leeg`;
  if (file.size > MAX_FILE_MB * 1024 * 1024) return `${file.name}: groter as ${MAX_FILE_MB} MB`;
  return "";
};

export const formatSize = (bytes) => (bytes >= 1048576 ? `${(bytes / 1048576).toFixed(1)} MB` : `${Math.max(1, Math.round(bytes / 1024))} KB`);

const PlanFilesAPI = {
  list: async (planId) => {
    const r = await fetch("/api/plan_files/" + planId, { headers: auth() });
    return r.ok ? r.json() : fail(r, "Kon nie die dokumente laai nie");
  },
  upload: async (planId, file) => {
    const body = new FormData();
    body.append("file", file);
    // no Content-Type header: the browser adds the multipart boundary
    const r = await fetch("/api/plan_files/" + planId, { method: "POST", headers: auth(), body });
    return r.ok ? r.json() : fail(r, `Kon nie ${file.name} stoor nie`);
  },
  download: async (fileId, filename) => {
    const r = await fetch("/api/plan_file/" + fileId, { headers: auth() });
    if (!r.ok) return fail(r, "Kon nie die dokument aflaai nie");
    const url = URL.createObjectURL(await r.blob());
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  },
  remove: async (fileId) => {
    const r = await fetch("/api/plan_file/" + fileId, { method: "DELETE", headers: auth() });
    return r.ok ? r.json() : fail(r, "Kon nie die dokument verwyder nie");
  },
};

export default PlanFilesAPI;
